@use "ui/styles/breakpoints";
@use "ui/styles/colors";
@use "ui/styles/effects";
@use "ui/styles/fonts";
@use "ui/styles/zindex";
@use "ui/styles/sizes";
$padding: 18px;
$modalPadding: 18px 24px;

.modalScreen {
  opacity: 0;
  transition: opacity 0.2s;
  z-index: zindex.$modal-screen;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: colors.$alphaDark50;
  backdrop-filter: blur(4px);
  height: 100%;
  visibility: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-height: 100%;
  align-items: center;
  overflow: auto;
  padding: $padding;
}

.transparentModalScreen {
  background-color: transparent;
}

.modalContainer {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  min-height: fit-content;
  width: 100%;
  align-items: center;
}

.showModal {
  opacity: 1;
  pointer-events: inherit;
  visibility: visible;
}

.modal {
  width: 100%;
  position: relative;
  border-radius: var(--border-radius);
  background-color: var(--background-color);
  box-shadow: effects.$boxShadow3XL;
  z-index: zindex.$modal;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: fit-content;
}

.header {
  width: 100%;
  display: flex;
  position: relative;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid var(--border-color);
  padding: $modalPadding;

  .title {
    flex: 1;
    font-weight: fonts.$medium;
  }

  .closeIcon {
    cursor: pointer;
    opacity: 0.75;

    &.disabled {
      opacity: 0.25;
      cursor: not-allowed;
    }
  }

  .closeIcon:not(.disabled):hover {
    opacity: 1;
  }
}

.internalHeader {
  width: 100%;
  display: flex;
  position: relative;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid var(--border-color);
}

.footer {
  width: 100%;
  display: flex;
  position: relative;
  flex-direction: row;
  align-items: center;
  border-top: 1px solid var(--border-color);

  &.footerButtons {
    justify-content: flex-end;
    gap: sizes.$s6;
    padding: $modalPadding;
  }
}

.small {
  max-width: 550px;
}

.medium {
  max-width: 750px;
}

.large {
  max-width: 980px;
}

.full {
  width: 100%;
}

.bodyWrapper {
  height: 100%;

  &.bodyPadding {
    padding: $modalPadding;
  }
}

.scrollable {
  overflow: hidden;

  .modalContainer {
    min-height: unset;
  }

  .modal {
    height: 700px;
    max-height: 90vh;
  }

  .bodyWrapper {
    @include effects.scrollbar;
    overflow-y: auto;
  }
}

.fullHeight {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  .modalContainer {
    height: calc(100% - $padding * 2);
  }

  .modal {
    height: 100%;
  }

  &.scrollable .modal {
    height: unset;
    max-height: 100%;
  }
}
